import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useForm, useWatch } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { setPostCreateWithdrawals } from '../../store/thunk/setPostCreateWithdrawals';
import FieldSelect from '../../../../../@casino/ui/Fields/Select';
import FieldInput from '../../../../../@casino/ui/Fields/Input';

const useStyles = makeStyles(() => ({
    root: {
        position: 'fixed',
        top: 0,
        left: 0,
        background: 'rgba(0,0,0,0.2)',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    form: {
        background: '#1c2542',
        borderRadius: 8,
        padding: 20,
        display: 'flex',
        minWidth: 500,
        display: 'flex', 
        flexDirection: 'column', 
        rowGap: '12px'
    },
    field: {
        padding: 10,
        paddingLeft: 10,
        border: '1px solid #141b33',
        outline: 'none',
        margin: 10,
        color: '#000',
        width: 'calc(100% - 40px)',
        '&::placeholder': {
            color: '#000'
        }
    },
    btn: {
        padding: '8px 14px',
        borderRadius: 4,
        background: 'gold',
        color: '#000',
        cursor: 'pointer',
        border: 'none',
        fontSize: 18
    },
    btn_disabled: {
        padding: '8px 13px',
        borderRadius: 4,
        background: 'none',
        color: '#ACACAC',
        border: '1px solid gold',
        cursor: 'pointer',
        fontSize: 18
    }
}))

const ModalWithdrawals = ({
    setIsPayout
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = React.useState(false);

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue
    } = useForm()

    const [amount, payment_system, currency, card_number] = useWatch({
        control,
        name: ['amount', 'payment_system', 'currency', 'card_number']
    });

    const onSubmit = (store) => {
        if (store.amount && store.card_number && !isLoading) {
            setIsLoading(true);
            dispatch(setPostCreateWithdrawals(store, setIsPayout, setIsLoading))
        }
    }

    const [currencyList, setCurrencyList] = React.useState([])

    const payments_list = [
        // {
        //     label: 'expay',
        //     value: 'expay'
        // }, 
    {
        label: 'alfakit',
        value: 'alfakit'
    }, 
    {
        label: 'piastrix',
        value: 'piastrix'
    }, 
    {
        label: 'repay',
        value: 'repay'
    }, 
    {
        label: 'repay SBP',
        value: 'repay_sbp'
    }, 
    {
        label: 'paylab',
        value: 'paylab'
    }];

    const bank_list = [
    {
        label: 'СберБанк',
        value: 'sberbank'
    },
    {
        label: 'Альфа Банк',
        value: 'alfabank',
    }, 
    {
        label: 'Райффайзен Банк',
        value: 'raifaizen',
    },
    {
        label: 'Т-Банк (Тинькофф)',
        value: 'tbank',
    },
    {
        label: 'Банк АВАНГАРД',
        value: 'bank_avangard',
    }, 
    {
        label: 'Банк Элита',
        value: 'bank_elita',
    }, 
    {
        label: 'Банк ФК Открытие',
        value: 'bank_fk_otkritie',
    },
    {
        label: 'ВТБ',
        value: 'vtb'
    }, 
    {
        label: 'МКБ (Московский кредитный банк)',
        value: 'mkb',
    }, 
    {
        label: 'Совкомбанк',
        value: 'sovkombank',
    }, 
   
    {
        label: 'Россельхозбанк',
        value: 'rosselhoz'
    }, 
    {
        label: 'ЮниКредит Банк',
        value: 'ynicredit',
    }, 
  
    {
        label: 'Промсвязьбанк',
        value: 'promsvyaz',
    },
    {
        label: 'Росбанк',
        value: 'rosbank'
    }, 
    {
        label: 'Газпромбанк',
        value: 'gazprom',
    }, 
    {
        label: 'Озон Банк (Ozon)',
        value: 'ozon',
    },
    {
        label: 'Ак Барс Банк',
        value: 'akbars'
    }, 
    {
        label: 'Хоум Кредит Банк (Хоум Банк)',
        value: 'homecreditbank',
    }, 
    {
        label: 'МТС  Банк  ',
        value: 'mtsbank',
    }, 
    {
        label: 'УБРиР',
        value: 'ybrir',
    }, 
    {
        label: 'Яндекс Банк',
        value: 'yandexbank',
    }, 
    {
        label: 'РНКБ Банк',
        value: 'rnkb',
    }, 
    {
        label: 'Почта Банк',
        value: 'pochtabank',
    }, 
    {
        label: 'Точка Банк',
        value: 'tochka',
    }];

    React.useEffect(() => {
        if (payment_system === 'alfakit' || payment_system === 'piastrix') {
            setCurrencyList([{
                label: 'RUB',
                value: 'RUB'
            }, {
                label: 'KZT',
                value: 'KZT'
            }, {
                label: 'UZS',
                value: 'UZS'
            }])
        }
        if (payment_system === 'repay' || payment_system === 'repay_sbp') {
            setCurrencyList([{
                label: 'RUB',
                value: 'RUB'
            }])
        }
        if (payment_system === 'paylab') {
            setCurrencyList([{
                label: 'UZS',
                value: 'UZS'
            }])
        }
        setValue('currency', '')
    }, [payment_system])

    const isValid = !amount || !payment_system || !currency || !card_number || isLoading;

    const handleCancel = () => {
        reset({})
        setIsPayout(false)
    }

    return (
        <div className={classes.root}>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                <FieldSelect
                    register={register}
                    label="Платежная система"
                    name="payment_system"
                    list={payments_list}
                    defaultOption="Выбрать платежную систему"
                    isLabel={false}
                />
                <FieldSelect
                    isLabel={false}
                    register={register}
                    label="Валюта"
                    name="currency"
                    list={currencyList}
                    defaultOption="Выбрать валюту"
                />
                {
                    payment_system === 'repay_sbp' && (
                        <FieldSelect
                            isLabel={false}
                            register={register}
                            label="Валюта"
                            name="bank"
                            list={bank_list}
                            defaultOption="Выбрать банк"
                        />
                    )
                }
                <FieldInput
                    name="card_number"
                    placeholder={payment_system === 'repay_sbp' ? "Введите номер телефона" : "Введите номер карты"}
                    type="number"
                    register={register}
                />
                {
                    payment_system === 'paylab' && (
                        <FieldInput
                            name="phone_number"
                            placeholder="Введите номер телефона"
                            type="number"
                            register={register}
                        />
                    )
                }
                <FieldInput
                    name="amount"
                    placeholder="Введите сумму"
                    type="number"
                    register={register}
                />
                
                <div style={{ display: 'flex', columnGap: 12, justifyContent: 'flex-end' }}>
                    <button
                        type="button"
                        onClick={handleCancel}
                        className={classes.btn_disabled}
                    >
                        Отменить
                    </button>
                    <button
                        type="submit"
                        disabled={isValid}
                        className={!isValid ? classes.btn : classes.btn_disabled}
                    >
                        Создать
                    </button>
                </div>
            </form>
        </div>
    )
}

export default ModalWithdrawals;